import React from 'react';
import { motion } from 'framer-motion';

export const MetricCard = ({ title, value, icon: Icon, color = "var(--accent-color)" }) => (
    <motion.div 
        whileHover={{ scale: 1.02 }}
        className="p-8 rounded-[2.5rem] border bg-[var(--bg-card)] border-[var(--border-color)] shadow-2xl relative overflow-hidden"
    >
        <div className="flex justify-between items-start">
            <div>
                <p className="text-[10px] font-black uppercase tracking-[0.3em] opacity-30 mb-2">{title}</p>
                <h3 className="text-3xl font-black tracking-tighter text-white">{value}</h3>
            </div>
            <div className="p-4 rounded-2xl bg-white/5 border border-white/10" style={{ color }}>
                <Icon size={24} />
            </div>
        </div>
        <div className="absolute -right-4 -bottom-4 w-24 h-24 opacity-5 blur-2xl" style={{ backgroundColor: color }}></div>
    </motion.div>
);